var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtributo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3535 12.9455L19.9979 12.3012V17.9979H14.301L15.2966 17.0022H19.0024V13.2966L19.3536 12.9454L19.3535 12.9455ZM20 6.00012V7.00012H19.9977V7.61074C19.3909 7.02949 18.5975 6.70949 17.7546 6.70949C17.283 6.70949 16.8272 6.81024 16.4105 7.00012H0.99775V17.0024H7.6545L7.32263 17.998H0.00224996V7.00024H0V6.00024H0.00224996V2.00249H5V0.500244H6V2.00249H14V0.500244H15V2.00249H19.9977V6.00024L20 6.00012ZM19.0023 2.99787H15V4.00012H14V2.99787H6V4.00012H5V2.99787H0.99775V6.00012H19.0021V2.99787H19.0023ZM19.3424 8.28274C19.7665 8.70687 20 9.27062 20 9.87049C20 10.4704 19.7665 11.034 19.3424 11.4581L12.4721 18.3282L7.7095 19.9157L9.297 15.1531L16.1682 8.28162L16.1704 8.27949C16.5943 7.85687 17.156 7.62512 17.7547 7.62512C18.3535 7.62512 18.9184 7.85862 19.3425 8.28274H19.3424ZM11.2762 17.6726L9.9525 16.3489L9.29062 18.3345L11.2762 17.6726ZM18.6353 8.98987C18.1509 8.50537 17.4206 8.49999 16.8774 8.98699L10.4411 15.4231L12.202 17.184L18.6353 10.7507C19.1208 10.2654 19.1208 9.47537 18.6353 8.98987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtributo);
export default __webpack_public_path__ + "static/media/atributo.67d740bfa41fb831c4948a3bdb85829b.svg";
export { ForwardRef as ReactComponent };